import {formatNumber, LocaleConfig} from 'platform/locale';

export function getNumberPreview(values: LocaleConfig): string | null {
  return formatNumber(values, 6492153.976, 2);
}
